const viewPage = (domain, customUrl) => {
  if (!domain || !customUrl) {
    throw new Error('Both domain and customUrl are required.');
  }
  const url = `${domain}/company/${customUrl}`;
  window.open(url, '_blank'); 
};

export default viewPage;
